import { useToastStore } from './store'
import styles from './Toast.module.css'
import type { ToastItem, ToastPosition } from './Toast.types'

type ToastContentProps = Pick<ToastItem, 'title' | 'message' | 'color'>

export const ToastContent = ({ title, message, color }: ToastContentProps) => (
    <div className={styles.toast} role="alert" data-color={color || undefined}>
        <div className={styles.title}>{title}</div>
        <div className={styles.message}>{message}</div>
    </div>
)

type ToastProps = {
    position?: ToastPosition
}

const Toast = ({ position = 'fixed' }: ToastProps) => {
    const toasts = useToastStore((state) => state.toasts)

    if (toasts.length === 0) {
        return null
    }

    return (
        <div className={styles.container} data-position={position}>
            {toasts.map(({ id, title, message, color }) => (
                <ToastContent
                    key={id}
                    title={title}
                    message={message}
                    color={color}
                />
            ))}
        </div>
    )
}

export default Toast
